<template>
    <div class=" w-full">
        <div class=" w-full flex justify-between mt-4">
            <jet-label class="text-black font-bold whitespace-nowrap col-span-6" v-bind:value="config.text"/>
            <div class="text-black">
                <label>
                    Desconsiderar filtro
                    <input type="checkbox" v-model="filterActive" @change="changeFilter()" class="ml-2">
                </label>
            </div>
        </div>
        <div class="flex items-center text-left mt-3">
            <div  :key="option.id" v-for="(option) in config.options" >
                <label :for="option.id" class=" ml-2 rounded-full h-12 w-12 flex items-center justify-center mr-1 cursor-default border border-black " :class="ClassCheckboxIcon[option.id]"  v-tippy :content="option.name" @click="addOrRemoveItem(option.id)">
                    <i v-if="option.icon" :class="option.icon"></i>
                    <img v-else :class="option.class" :src="option.img" alt="">
                </label>
            </div>
        </div>
    </div>


</template>

<script>
    import JetLabel from "../../Jetstream/Label.vue";

    export default {
        components:{
            JetLabel
        },
        props: {
            config: {
                default: () => {}
            },
            value: [String, Object,Boolean,Number,Array],

        },
        watch: {
            value: function (val) {
                this.itemsSelected = val;
            }
        },
        data() {
            return {
                itemsSelected: [],
                filterActive : true,
                ClassCheckboxIcon : [],
            }
        },
        methods:{
            changeFilter() {
                this.itemsSelected = [];
                if(this.filterActive){
                     this.$emit('input', this.itemsSelected);
                }
                this.reloadClassCheckboxIcon();
            },
            reloadClassCheckboxIcon() {
                if(this.config.type === 'checkbox_icon'){


                    this.ClassCheckboxIcon = [];
                    this.config.options.forEach(item => {
                        this.setClassCheckboxIcon(item.id);
                    });
                }

            },
            setClassCheckboxIcon(item) {
                this.ClassCheckboxIcon[item] =  {
                    'text-black opacity-50 cursor-not-allowed': this.filterActive,
                    'cursor-pointer': !this.filterActive,
                    'text-black bg-blue-500 border-white': this.itemsSelected.includes(item) && !this.filterActive ,
                    'text-black hover:text-black hover:bg-white': !this.itemsSelected.includes(item) && !this.filterActive,
                }
            },
            addOrRemoveItem(item) {

                this.itemsSelected = this.itemsSelected ? this.itemsSelected : [];

                if(!this.filterActive) {
                    if (this.itemsSelected.includes(item)) {
                        this.itemsSelected = this.itemsSelected.filter(itemFilter => itemFilter !== item);
                    } else {
                        this.itemsSelected.push(item);
                    }

                    this.$emit('input', this.itemsSelected);

                    this.reloadClassCheckboxIcon();
                }

            },
        },
        created(){
            this.itemsSelected = this.value ? this.value : [];
            this.filterActive = !(this.itemsSelected.length > 0);
            this.reloadClassCheckboxIcon();
        }

    }
</script>
